
import { CompetitionMatch } from "../../types/competition";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";

interface CompetitionDetailsProps {
  totalMatches?: number;
  totalWins?: number;
  weightClasses?: string;
  finish?: string;
  matches?: CompetitionMatch[];
}

export function CompetitionDetails({
  totalMatches,
  totalWins,
  weightClasses,
  finish,
  matches
}: CompetitionDetailsProps) {
  const winPercentage = totalMatches && totalWins 
    ? Math.round((totalWins / totalMatches) * 100) 
    : 0;

  return (
    <div className="space-y-4">
      {/* Competition Overview */}
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
        <Card>
          <CardHeader className="pb-2">
            <CardTitle className="text-sm">Total Matches</CardTitle>
          </CardHeader>
          <CardContent className="pt-0 text-2xl font-bold">
            {totalMatches || 0}
          </CardContent>
        </Card>
        
        <Card>
          <CardHeader className="pb-2">
            <CardTitle className="text-sm">Wins</CardTitle>
          </CardHeader>
          <CardContent className="pt-0 text-2xl font-bold">
            {totalWins || 0} ({winPercentage}%)
          </CardContent>
        </Card>

        {weightClasses && (
          <Card>
            <CardHeader className="pb-2">
              <CardTitle className="text-sm">Weight Classes</CardTitle>
            </CardHeader>
            <CardContent className="pt-0">
              {weightClasses}
            </CardContent>
          </Card>
        )}

        {finish && (
          <Card>
            <CardHeader className="pb-2">
              <CardTitle className="text-sm">Final Result</CardTitle>
            </CardHeader>
            <CardContent className="pt-0 font-semibold">
              {finish}
            </CardContent>
          </Card>
        )}
      </div>

      {/* Match Details */}
      {matches && matches.length > 0 && (
        <Card>
          <CardHeader>
            <CardTitle>Match Details</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="space-y-4">
              {matches.map((match, index) => (
                <div 
                  key={index}
                  className="flex flex-col space-y-2 p-4 border rounded-lg"
                >
                  <div className="flex justify-between items-center">
                    <div className="flex space-x-2">
                      <Badge>{match.gi_nogi}</Badge>
                      <Badge variant="outline">{match.division}</Badge>
                      <Badge variant="outline">{match.weight_class}</Badge>
                    </div>
                    <Badge 
                      variant={match.result === "win" ? "default" : "destructive"}
                    >
                      {match.result.toUpperCase()}
                    </Badge>
                  </div>
                  <div className="text-sm text-muted-foreground">
                    Method: {match.method}
                  </div>
                  {match.video_url && (
                    <a 
                      href={match.video_url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-sm text-blue-500 hover:underline"
                    >
                      Watch Match Video
                    </a>
                  )}
                </div>
              ))}
            </div>
          </CardContent>
        </Card>
      )}
    </div>
  );
}
